'use client';

import { motion } from 'framer-motion';

export default function SquareAnimate() {
  const duration = 1;

  return (
    <motion.svg
      viewBox="0 0 260 260"
      xmlns="http://www.w3.org/2000/svg"
      className="mx-auto fill-fg-light dark:fill-fg-dark"
    >
      <g transform="scale(4)">
        <defs id="SvgjsDefs164444"></defs>
        <g
          id="SvgjsG1642"
          transform="matrix(0.7625272331154684,0,0,0.7625272331154684,-1.9063180827886712,-1.9063180827886712)"
        >
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              delay: (duration / 6) * 1,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M64.211,42.71l13.828-24.433C70.248,8.656,58.346,2.5,45,2.5c-1.125,0-2.235,0.057-3.337,0.143L64.211,42.71z"
          ></motion.path>
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M52.7,26.875L39.21,2.903C24.729,4.877,12.572,14.136,6.555,26.875H52.7z"
          ></motion.path>
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              delay: (duration / 6) * 2,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M56.543,60.859h27.888C86.404,55.957,87.5,50.608,87.5,45c0-9.242-2.959-17.787-7.968-24.76L56.543,60.859z"
          ></motion.path>
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              delay: (duration / 6) * 5,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M33.45,29.141H5.571C3.597,34.042,2.5,39.392,2.5,45c0,9.19,2.927,17.693,7.887,24.646L33.45,29.141z"
          ></motion.path>
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              delay: (duration / 6) * 3,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M37.35,63.125L50.9,87.083c14.433-2.006,26.544-11.252,32.546-23.958H37.35z"
          ></motion.path>
          <motion.path
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration,
              delay: (duration / 6) * 4,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M25.757,47.231L11.875,71.614C19.665,81.298,31.605,87.5,45,87.5c1.163,0,2.31-0.06,3.449-0.151L25.757,47.231z"
          ></motion.path>
        </g>
      </g>
    </motion.svg>
  );
}
